import Base, { baseInit } from './base';

class LineItemProductType extends Base {
  id = null; // Integer
  productTypeId = null; // Integer
  categoryPath = null; // String

  constructor(data) {
    super(data);
    baseInit(this, data, true);
  }
}

export default LineItemProductType;
